
import { Component, Prop, Vue } from "vue-property-decorator";
import { actions, AttachmentMeta } from "@/survey";
import FileUploadInput from "@/components/FileUploadInput.vue";

@Component({
  components: { FileUploadInput }
})
export default class DisplayImageId extends Vue {
  @Prop() private meta?: AttachmentMeta;
  apiLocation = Vue.prototype.$apiLocation;

  get imageWidth() {
    return this.$data.editingComment ? 360 : 180;
  }

  get displayName(): string {
    return this.rawFileName || `${this.contentTypeExtension} file`;
  }

  get rawFileName(): string {
    return this.$props.meta.name || this.$props.meta.originalfilename || "";
  }

  get fileExtension(): string {
    const fileName: string = this.rawFileName;
    const lastDot = fileName.lastIndexOf(".");
    if (lastDot > -1 && lastDot < fileName.length - 1) {
      return fileName.substr(lastDot + 1).toLowerCase();
    }
    return this.contentTypeExtension;
  }

  get formattedSize(): string {
    const size = this.$props.meta.sizebytes;
    if (size === null || size === undefined) {
      return "";
    }
    if (size < 1024) {
      return `${size} B`;
    }
    if (size < 1024 * 1024) {
      return `${(size / 1024).toFixed(1)} KB`;
    }
    return `${(size / 1024 / 1024).toFixed(1)} MB`;
  }

  get rotatingPlaceholderSrc() {
    return this.placeholderSvg("rotating...");
  }

  data() {
    return {
      image: null,
      editingComment: false,
      replacingImage: false,
      rotatingImage: false,
      lclComments: this.$props.meta.notes,
      rotation: 0,
      imageKey: 0
    };
  }

  placeholderSvg(text: string) {
    return `data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20width='100'%20height='100'%20viewBox='0%200%20100%20100'%3E%3Crect%20width='100'%20height='100'%20fill='%23f1f3f5'/%3E%3Ctext%20x='50'%20y='52'%20text-anchor='middle'%20font-family='Arial'%20font-size='12'%20fill='%236c757d'%3E${encodeURIComponent(text)}%3C/text%3E%3C/svg%3E`;
  }

  toggleReplacing() {
    this.$data.replacingImage = !this.$data.replacingImage;
  }

  toggleEdit() {
    this.$data.editingComment = !this.$data.editingComment;
  }

  deleteImage() {
    if (confirm("This will delete the image, are you sure?")) {
      this.$store.dispatch(actions.DELETE_IMAGE, { id: this.$props.meta.id });
    }
  }

  saveComment() {
    this.$store.dispatch(actions.ADD_COMMENT, {
      table: "attach",
      id: this.$props.meta.id,
      comment: this.$data.lclComments,
      recordTable: this.$props.meta.tablename
    });
    this.toggleEdit();
  }

  getExtension() {
    return this.contentTypeExtension;
  }

  get contentTypeExtension(): string {
    if (!this.$props.meta.contenttype || this.$props.meta.contenttype.indexOf("/") === -1) {
      return "file";
    }
    return this.$props.meta.contenttype.split("/")[1];
  }

  isImage() {
    return this.getContentType() === "image";
  }

  getContentType() {
    return this.$props.meta.contenttype.split("/")[0];
  }

  replaceImage() {
    const meta: AttachmentMeta = this.$props.meta;

    this.$store.dispatch(actions.UPLOAD_FILE, {
      image: this.$data.image,
      imageComment: meta.notes,
      uploadName: this.$data.image.name,
      tableName: meta.tablename,
      recordId: meta.recordid,
      id: meta.id,
      // rotation: this.$data.rotation,
      success: () => {
        this.toggleReplacing();
      },
      attachmentType: meta.attachmentType
    });
  }

  downloadImage() {
    const image = this.$refs.image as HTMLImageElement;
    const url = image.src.replace(
        /^data:[a-zA-Z]+\/[^;]+/,
        "data:application/octet-stream"
    );
    const link = document.createElement("a") as HTMLAnchorElement;
    link.id = "dl";
    link.href = url;
    link.download = `${this.$props.meta.name}`;
    link.click();
    link.remove();
  }

  rotateImage() {
    this.$data.rotatingImage = true;
    this.$data.rotation = this.$data.rotation + 90;
    (this.$refs.image as any).style.transform = `rotate(${this.$data.rotation}deg)`;
    this.$store.dispatch(actions.ROTATE_IMAGE, {
      tableName: this.meta!!.tablename, imageId: this.meta!!.id, rotation: this.$data.rotation
    }).then(() => {
      this.$data.imageKey = new Date().getTime();
      this.$data.rotatingImage = false;
    }).catch(() => this.$data.rotatingImage = false);
  }
}
